export class IroningPackageModel {
    name: string;
    minQuantity: number;
    maxQuantity: number;
    price: number;
    constructor(name: string, minQuantity: number, maxQuantity: number, price: number) {
        this.name = name;
        this.minQuantity = minQuantity;
        this.maxQuantity = maxQuantity;
        this.price = price;
    }
}
